/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {
    GET_QUESTIONS_ANSWERED,
    QUESTIONS_ANSWERED_FETCHING,
    GET_TOP_QUESTIONS,
    TOP_QUESTIONS_FETCHING,
    GET_AVG_IN_VIEW,
    AVG_IN_VIEW_FETCHING,
    GET_UNIQUE_USERS,
    UNIQUE_USERS_FETCHING,
    GET_REVENUE_METRICS_TOTAL,
    GET_REVENUE_METRICS_TOTAL_FETCHING,
    GET_TOP_STORIES,
    TOP_STORIES_FETCHING,
    GET_TOTAL_STORY_CLICKS,
    TOTAL_STORY_CLICKS_FETCHING
} from 'state/actions/homeState/home_analytics_data';
import { CLEAR_ALL_STATES } from 'state/actions/auth_status';



/* ========== ~~~~~~~~~~ HOME ANALYTICS DATA : REDUCER ~~~~~~~~~~ ========== */
// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const defaultStatus = {
    adMetricsData: {
        revenue: {},
        cpm: {},
        impression: {},
        rmsFetching: false
    },
    contentPerformanceData: {
        questionsAnswered: {},
        fetchingQuestions: false,
        questionsAnsweredDetail:{},
        topQuestionsAnswered:[],
        fetchingTopQuestion: false,
        topQuestionsAnsweredDetail: []
    },
    stories: {
        totalStoryClicks: {},
        fetchingTotalStoryClicks: false,
        topStories: [],
        fetchingTopStories: false
    },
    embedEngagementData: {
        averageInView: {},
        fetchingAverageInView: false,
        averageInViewDetail: {},
        uniqueEngagedUsers: {},
        fetchingUniqueEngagedUsers: false,
        uniqueEngagedUsersDetail: {}
    }
};


const homeAnalyticsData = (state = defaultStatus, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case GET_QUESTIONS_ANSWERED:
            newState.contentPerformanceData.questionsAnswered = action.data;
            return newState;
        case QUESTIONS_ANSWERED_FETCHING:
            newState.contentPerformanceData.questionsAnswered = {};
            newState.contentPerformanceData.fetchingQuestions = action.status;
            return newState;
        case GET_TOP_QUESTIONS:
            newState.contentPerformanceData.topQuestionsAnswered = action.data;
            return newState;
        case TOP_QUESTIONS_FETCHING:
            newState.contentPerformanceData.topQuestionsAnswered = {};
            newState.contentPerformanceData.fetchingTopQuestion = action.status;
            return newState;
        case GET_AVG_IN_VIEW:
            newState.embedEngagementData.averageInView = action.data;
            return newState;
        case AVG_IN_VIEW_FETCHING:
            newState.embedEngagementData.averageInView = {};
            newState.embedEngagementData.fetchingAverageInView = action.status;
            return newState;
        case GET_UNIQUE_USERS:
            newState.embedEngagementData.uniqueEngagedUsers = action.data;
            return newState;
        case UNIQUE_USERS_FETCHING:
            newState.embedEngagementData.uniqueEngagedUsers = {};
            newState.embedEngagementData.fetchingUniqueEngagedUsers = action.status;
            return newState;
        case GET_REVENUE_METRICS_TOTAL:
            newState.adMetricsData.cpm = action.cpm;
            newState.adMetricsData.revenue = action.revenue;
            newState.adMetricsData.impression = action.impression;
            return newState;
        case GET_REVENUE_METRICS_TOTAL_FETCHING:
            newState.adMetricsData.cpm = {};
            newState.adMetricsData.revenue = {};
            newState.adMetricsData.impression = {};
            newState.adMetricsData.rmsFetching = action.bool;
            return newState;
        case TOP_STORIES_FETCHING:
            newState.stories.fetchingTopStories = action.status;
            return newState;
        case GET_TOP_STORIES:
            newState.stories.topStories = action.data;
            return newState;
        case TOTAL_STORY_CLICKS_FETCHING:
            newState.stories.fetchingTotalStoryClicks = action.status;
            return newState;
        case GET_TOTAL_STORY_CLICKS:
            newState.stories.totalStoryClicks = action.data;
            return newState;
        case CLEAR_ALL_STATES:
            return defaultStatus;
        default:
            return newState;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default homeAnalyticsData;